import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleQuestion } from "@fortawesome/free-solid-svg-icons";
import { TFunction } from "i18next";

import { isDarkColor } from "../../../config/DarkColorChecker";
import { BackButton } from "../../common/BackButton";

type InvoiceWebHeaderProps = {
  active: string;
  accentColor?: string;
  title: string;
  t: TFunction;
  onOpenInformation: () => void;
  onTabChange: (tab: string) => void;
};

const tabs = ["all", "history", "summary"];

export const InvoiceWebHeader = ({
  active,
  accentColor,
  title,
  t,
  onOpenInformation,
  onTabChange,
}: InvoiceWebHeaderProps) => {
  return (
    <>
      <div className="h-full flex justify-between items-center">
        <div className="flex p-4">
          <BackButton />
          <div className="text-4xl font-bold">{title}</div>
        </div>
        <button onClick={onOpenInformation} className="mr-4">
          <FontAwesomeIcon
            icon={faCircleQuestion}
            className="text-slate-500 size-5 hover:text-slate-700"
          />
        </button>
      </div>
      <div className="pb-4">
        {tabs.map((tab) => {
          const isActive = active === tab;

          return (
            <button
              key={tab}
              onClick={() => onTabChange(tab)}
              style={
                isActive
                  ? {
                      backgroundColor: accentColor,
                      color: isDarkColor(accentColor) ? "white" : "black",
                    }
                  : { color: "grey" }
              }
              className={
                isActive
                  ? `px-4 py-2 ml-3 rounded-full text-lg ${
                      isDarkColor(accentColor)
                        ? "text-white hover:text-white"
                        : "text-black hover:text-black"
                    }`
                  : "px-4 py-2 ml-3 rounded-full text-lg hover:font-semibold"
              }
            >
              {t(`INVOICE.${tab === "all" ? "title" : tab}`)}
            </button>
          );
        })}
      </div>
    </>
  );
};
